import { render, staticRenderFns } from "./LayoutInternas.vue?vue&type=template&id=322fa418&scoped=true&"
import script from "./LayoutInternas.vue?vue&type=script&lang=js&"
export * from "./LayoutInternas.vue?vue&type=script&lang=js&"
import style0 from "./LayoutInternas.vue?vue&type=style&index=0&id=322fa418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322fa418",
  null
  
)

export default component.exports